const RAVOTXOJI_MONTH_NAMES = [
  "yan",
  "fev",
  "mar",
  "apr",
  "may",
  "iyun",
  "iyul",
  "avg",
  "sen",
  "okt",
  "noy",
  "dek",
];

const RAVOTXOJI_HOURS = [1, 3, 5, 7, 9, 11, 13, 15, 17, 19, 21, 23];

export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const addDays = (dateString, days) => {
  const [year, month, day] = String(dateString)
    .split("-")
    .map((item) => parseInt(item, 10));
  const date = new Date(year, month - 1, day);
  date.setDate(date.getDate() + days);

  return formatDate(date);
};

export const getDefaultRange = () => {
  const today = formatDate(new Date());

  return {
    from: addDays(today, -13),
    to: today,
  };
};

export const isValidRange = ({ from, to }) => {
  return Boolean(from && to && from <= to);
};

export const getMonthsInRange = (from, to) => {
  if (!isValidRange({ from, to })) {
    return [];
  }

  const [fromYear, fromMonth] = from
    .split("-")
    .map((item) => parseInt(item, 10));
  const [toYear, toMonth] = to.split("-").map((item) => parseInt(item, 10));
  const cursor = new Date(fromYear, fromMonth - 1, 1);
  const end = new Date(toYear, toMonth - 1, 1);
  const months = [];

  while (cursor <= end) {
    months.push(`${cursor.getFullYear()}-${String(cursor.getMonth() + 1).padStart(2, "0")}`);
    cursor.setMonth(cursor.getMonth() + 1);
  }

  return months;
};

export const getDateColumnsInRange = (from, to) => {
  if (!isValidRange({ from, to })) {
    return [];
  }

  const columns = [];
  let cursor = new Date(`${from}T00:00:00`);
  const end = new Date(`${to}T00:00:00`);

  while (cursor <= end) {
    const date = formatDate(cursor);
    const month = date.slice(0, 7);
    const day = cursor.getDate();
    const monthName = RAVOTXOJI_MONTH_NAMES[cursor.getMonth()] || "";

    columns.push({
      date,
      day,
      month,
      label: `${day} ${monthName}`,
    });

    cursor.setDate(cursor.getDate() + 1);
  }

  return columns;
};

export const getMonthRange = (month) => {
  const [year, monthNumber] = String(month || "")
    .split("-")
    .map((item) => parseInt(item, 10));

  if (!year || !monthNumber) {
    return null;
  }

  const lastDay = new Date(year, monthNumber, 0).getDate();

  return {
    from: `${year}-${String(monthNumber).padStart(2, "0")}-01`,
    to: `${year}-${String(monthNumber).padStart(2, "0")}-${String(lastDay).padStart(2, "0")}`,
  };
};

export const normalizeRangeData = (monthlyDataByMonth, columns) => {
  const result = {};

  RAVOTXOJI_HOURS.forEach((hour) => {
    ["r", "z"].forEach((prefix) => {
      const key = `${prefix}${hour}`;
      result[key] = {};

      columns.forEach((column, index) => {
        result[key][index + 1] =
          monthlyDataByMonth?.[column.month]?.[key]?.[column.day];
      });
    });
  });

  return result;
};

export const getDayFromValue = (value) => {
  const stringValue = String(value || "");
  const isoMatch = stringValue.match(/^\d{4}-\d{2}-(\d{2})/);
  const dottedMatch = stringValue.match(/^(\d{1,2})\.\d{1,2}\.\d{4}$/);
  const compactMatch = stringValue.match(/^\d{4}\d{2}(\d{2})$/);

  if (isoMatch) {
    return parseInt(isoMatch[1], 10);
  }

  if (dottedMatch) {
    return parseInt(dottedMatch[1], 10);
  }

  if (compactMatch) {
    return parseInt(compactMatch[1], 10);
  }

  return parseInt(stringValue.slice(6, 8), 10);
};

export const normalizeRangeRows = (monthlyDataByMonth, columns, createEmptyRow) => {
  return columns.flatMap((column) => {
    const rows = monthlyDataByMonth?.[column.month];

    const matchedRows = Array.isArray(rows)
      ? rows
          .filter((row) => getDayFromValue(row?.sana) === column.day)
          .map((row) => ({
            ...row,
            __date: column.date,
            __month: column.month,
          }))
      : [];

    if (matchedRows.length || !createEmptyRow) {
      return matchedRows;
    }

    return [
      {
        ...createEmptyRow(column),
        __date: column.date,
        __month: column.month,
      },
    ];
  });
};

export const formatDisplayDate = (date) => {
  if (!date) {
    return "";
  }

  return date.split("-").reverse().join(".");
};
